import { render, staticRenderFns } from "./RemittanceOrderForm.vue?vue&type=template&id=2f2088f0&"
import script from "./RemittanceOrderForm.vue?vue&type=script&lang=js&"
export * from "./RemittanceOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports